import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48d66a78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cart_mobile-icon" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "count"
}
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = {
  key: 0,
  class: "count"
}
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = {
  key: 0,
  class: "count"
}
const _hoisted_8 = { class: "copyright" }
const _hoisted_9 = { class: "app-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["menu-toggle", { 'menu-toggle_close': $setup.showMenu }]),
      onClick: _cache[0] || (_cache[0] = () => $setup.toggleMenu(!$setup.showMenu))
    }, null, 2),
    _createVNode(_component_router_link, {
      class: "logo",
      to: { name: $setup.routesName.index }
    }, null, 8, ["to"]),
    (!$setup.showMenu)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "cart_mobile",
          to: { name: $setup.routesName.order }
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            ($setup.totalOrders)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.totalOrders), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItems, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "menu-item",
          key: index
        }, [
          _createVNode(_component_router_link, {
            class: "menu-link",
            to: { name: item.routeName },
            "active-class": "menu-link_active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(item.title), 1),
              (item.count)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.count), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["drawer", { drawer_active: $setup.showMenu }])
    }, [
      _createElementVNode("ul", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuItemsMobile, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "menu-item",
            key: index
          }, [
            _createVNode(_component_router_link, {
              class: "menu-link",
              to: { name: item.routeName },
              "active-class": "menu-link_active"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["icon", `icon_${item.icon}`])
                }, null, 2),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(item.title), 1),
                  (item.count)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.count), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(`© Copyright ${new Date().getFullYear()} Colorado Sports Video.`), 1)
      ])
    ], 2)
  ]))
}